module.exports = __webpack_public_path__ + "media/points_re/bill-98ead2ef.png";